// extracted by mini-css-extract-plugin
export default {"noWrap":"noWrap__u1ShO"};